module.exports = __webpack_public_path__ + "img/post3.059c45f8.jpg";